import React from "react";
import { AppState } from "store";
import { useSelector } from "react-redux";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useTodosFromState(): { todoCount: number | undefined; items: WintSuperkollAPIModel.Todo[] | undefined } {
  const { todoCount, itemMap, items } = useSelector((store: AppState) => store.todos);

  const itemArray = React.useMemo(() => {
    return items?.map((t) => itemMap?.get(t) as WintSuperkollAPIModel.Todo).toArray();
  }, [itemMap, items]);

  return {
    todoCount: todoCount,
    items: itemArray,
  };
}

export default useTodosFromState;
